import { ArrowLeft } from '@core/ui';
import type { LinkProps as BaseLinkProps } from '@online-webinar/router';
import { Link as BaseLink } from '@tanstack/react-router';

export interface BackLinkProps extends BaseLinkProps {
    classNames?: string;
}

export const BackLink = ({ classNames = '', children, ...props }: BackLinkProps) => (
    <BaseLink className={`group font-medium text-primary inline-flex items-center mb-4 md:mb-10 ${classNames}`} {...props}>
        <ArrowLeft classNames="h-auto w-2.5 mr-2 stroke-primary fill-transparent group-hover:fill-primary transition-color ease-in-out duration-200" />
        <>{children}</>
    </BaseLink>
);
